var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEyeOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_17)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 2.6666C4.74084 2.6666 1.88237 4.61701 0.235667 7.55612C0.0811669 7.83188 0.0811547 8.16813 0.235635 8.4439C1.88234 11.3835 4.74082 13.3334 8 13.3334C11.2592 13.3334 14.1177 11.3835 15.7644 8.4439C15.9188 8.16813 15.9188 7.83188 15.7643 7.55612C14.1176 4.61701 11.2592 2.6666 8 2.6666ZM8 11.3334C6.15879 11.3334 4.6666 9.84121 4.6666 8C4.6666 6.15879 6.15879 4.6666 8 4.6666C9.84121 4.6666 11.3334 6.15879 11.3334 8C11.3334 9.84121 9.84121 11.3334 8 11.3334Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z",
    fill: "#9E9E9E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEyeOn);
export default __webpack_public_path__ + "static/media/ic-eye-on.80b1c46da0c7db959fb3a795d2cc4a1e.svg";
export { ForwardRef as ReactComponent };